import { render, staticRenderFns } from "./RightMenuSettingZone.vue?vue&type=template&id=6c68a987"
import script from "./RightMenuSettingZone.vue?vue&type=script&lang=js"
export * from "./RightMenuSettingZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports